import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import './MedicationForms.css';
import { fetchUserEdgeData, saveMedicationMetaDoc, fetchFormDataMedication } from '../../../services/hih/Service';
import axios from "axios";
import Select from 'react-select';
import moment from 'moment';
import MedicationsList from './MedicationsList';
import { FaBullseye } from 'react-icons/fa6';
import MedicationsSupplierList from './MedicationsSupplierList';
import LocationDisplay from '../../cn/components/OCRDocument/LocationDisplay';
import { getWAMessageDetails } from '../../utils/Utils';


const MedicationFormsMetaDoc = ({ closeModal, selectedServiceRecord, callHomeBasedServicesHistory, memberBasicInfo, aiBupaServiceRecommendations, getAiBupaServiceRecommendations, handleFamilyMemberProfileClick }) => {

    const userId = memberBasicInfo.userId;

    const [error, setError] = useState("");
    const [message, setMessage] = useState("");
    const [disabledButton, setDisabledButton] = useState(true);
    const [showRemove, setShowRemove] = useState(false);
    const [cityList, setCityList] = useState([]);
    const [frequencyList, setFrequencyList] = useState([]);
    const [partnerList, setPartnerList] = useState([]);
    const [pharmacyList, setPharmacyList] = useState([]);
    const [showOcr, setShowOcr] = useState("");
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [savedPharmacy, setSavedPharmacy] = useState({
        vendorId: '',
        vendorName: ''
    });

    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0];

    const medicationsObj = {
        productId: '',
        productName: '',
        quantity: '',
        comments: '',
        frequency: '',
        duration: '',
        supplyFrom: formattedDate,
        supplyTo: '',
        sfdaCode: '',
        source: '',
        recommendationId: ''
    }

    const supplierObj = {
        productId: '',
        productName: '',
        quantity: '',
        comments: '',
        sfdaCode: '',
        source: '',
        recommendationId: ''
    }

    let aiBupaMedicines = [];
    let matchedMedicines = [];

    if (aiBupaServiceRecommendations[0]?.medicines?.length > 0) {
        matchedMedicines = aiBupaServiceRecommendations[0].medicines.filter(
            item => item.matchFound === 'Y' && item.medType === 'medications'
        );

        aiBupaMedicines = matchedMedicines.map((item) => ({
            productId: item.medicineId || '',
            productName: item.serviceDesc || '',
            quantity: item.servicelineItemQuantity || '',
            comments: '',
            frequency: item.calculatedFrequencyId || '',
            supplyFrom: item.calculatedSupplyFrom || '',
            supplyTo: item.calculatedSupplyTo || '',
            duration: item.calculatedDuration || '',
            sfdaCode: item.serviceCode || '',
            source: item.dataSource || '',
            recommendationId: item.recommendationId
        }));
    }


    let aiBupaMedicinesSupplies = [];
    let matchedSupplies = [];

    if (aiBupaServiceRecommendations[0]?.medicines?.length > 0) {
        matchedSupplies = aiBupaServiceRecommendations[0].medicines.filter(
            item => item.matchFound === 'Y' && item.medType === 'supplies'
        );

        aiBupaMedicinesSupplies = matchedSupplies.map((item) => ({
            productId: item.medicineId || '',
            productName: item.serviceDesc || '',
            quantity: item.servicelineItemQuantity || '',
            comments: '',
            sfdaCode: item.serviceCode || '',
            source: item.dataSource || '',
            recommendationId: item.recommendationId
        }));
    }

    const [formData, setFormData] = useState({
        userId: userId,
        selectedServiceRecord: selectedServiceRecord,
        membership: '',
        name: '',
        mobileNumber: '',
        partnerClinic: '',
        remarks: '',
        nationality: '',
        pharmacy: '',
        labProviderName: '',
        deliveryRefill: '',
        orderType: '',
        city: '',
        district: '',
        deductible: '',
        medications: (aiBupaServiceRecommendations[0]?.medicines?.filter(item => item.matchFound === 'Y' && item.medType === 'medications')?.length > 0) ? aiBupaMedicines : '',
        cityId: '',
        address: '',
        latitude: '',
        longitude: '',
        imageUrl: '',
        addressType: '',
        mediaUrl: '',
        flowId: '',
        memberRequestId: '',
        medicationsCount: matchedMedicines.length,
        suppliesCount: matchedSupplies.length,
        supplierMedications: (aiBupaServiceRecommendations[0]?.medicines?.filter(item => item.matchFound === 'Y' && item.medType === 'supplies')?.length > 0) ? aiBupaMedicinesSupplies : ''
    });

    const [addMedicationsComponentCount, setAddMedicationsComponentCount] = useState(formData.medications.length);
    const [addSuppliesComponentCount, setAddSuppliesComponentCount] = useState(formData.supplierMedications.length);

    // const [ocrData, setOcrData] = useState({
    //     medications: [
    //         {
    //             productName: '',
    //             quantity: '',
    //             frequency: '',
    //             duration: '',
    //             supplyFrom: '',
    //             supplyTo: ''
    //         }
    //     ],
    //     additionalInfo: ''
    // });

    useEffect(() => {
        fetchUserData();
        dropdownData();

        // if (aiBupaServiceRecommendations[0]?.medicines?.length > 1) {
        //     setShowRemove(true);
        // }
    }, [])


    const fetchUserData = async () => {
        const request = axios.CancelToken.source();
        let ct = {
            cancelToken: request.token
        }
        setDisabledButton(true);

        await fetchUserEdgeData(userId, 'metaService-med')
            .then((response) => {
                if (response.data.code === 200) {
                    setFormData((prev) => ({
                        ...prev, membership: memberBasicInfo.membershipNumber, name: memberBasicInfo.memberName, mobileNumber: memberBasicInfo.mobile, nationality: response.data.data.info.nationality,
                        cityId: response.data.data.info.cityId, city: response.data.data.info.cityName, addressType: response.data.data.info.addressType,
                        address: response.data.data.info.address, latitude: response.data.data.info.latitude, longitude: response.data.data.info.longitude,
                        imageUrl: response.data.data.info.imageUrl, mediaUrl: response.data.data.info.mediaUrl,
                        deliveryRefill: response.data.data.info.deliveryRefill, orderType: response.data.data.info.orderType,
                        partnerClinic: response.data.data.info.partnerClinic, pharmacy: response.data.data.info.pharmacyId,
                        labProviderName: response.data.data.info.pharmacyName, flowId: response.data.data.info.flowId, memberRequestId: response.data.data.info.memberRequestId
                    }));

                    setSavedPharmacy((prev) => ({ ...prev, vendorId: response.data.data.info.pharmacyId, vendorName: response.data.data.info.pharmacyName }));
                    setShowOcr(response.data.data.info.showOcr);

                    if (response.data.data.info.cityId > 0) {
                        fetchCategoryList(response.data.data.info.cityId);
                    }

                    // if (response.data.data.info.showOcr == true) {  
                    //     const formattedMeds = (response.data.data.info.ocrMedcine || []).map(med => ({
                    //         productName: med.serviceDesc || '',
                    //         quantity: med.servicelineItemQuantity || '',
                    //         frequency: med.frequencyName || '',
                    //         duration: med.calculatedDuration || '',
                    //         supplyFrom: med.calculatedSupplyFrom || '',
                    //         supplyTo: med.calculatedSupplyTo || ''
                    //     }));

                    //     setOcrData(prev => ({
                    //         ...prev,
                    //         medications: formattedMeds,
                    //         additionalInfo: response.data.data.info.additionalInfo
                    //     }));
                    // }
                    setDisabledButton(false);
                } else {
                    setError(response.data.data.message);
                }
            }).catch(function (error) {
                console.log(error);
            });
        return () => request.cancel();
    }


    const handleChange = async (e) => {
        const { name, value } = e.target;

        const updatedFormData = { ...formData, [name]: value };

        if (name === "pharmacy") {
            updatedFormData.labProviderName = e.target.selectedOptions[0].text;
        }

        if (name === "mobileNumber") {
            if (!value.startsWith('0')) {
                updatedFormData.mobileNumber = ('0' + value).slice(0, 11);
            } else if (value.length === 1 && value === '0') {
                updatedFormData.mobileNumber = '0';
            } else {
                updatedFormData.mobileNumber = value.slice(0, 11);
            }
        }
        if (name === "deliveryRefill") {
            if (value === "delivery") {
                updatedFormData.pharmacy = '';
                updatedFormData.labProviderName = '';
                setSavedPharmacy((prev) => ({ ...prev, vendorId: formData.pharmacy, vendorName: formData.labProviderName }));
            } else {
                updatedFormData.pharmacy = savedPharmacy.vendorId;
                updatedFormData.labProviderName = savedPharmacy.vendorName;
            }
        }

        setFormData(updatedFormData);
        setError('');
    };

    const validateForm = () => {
        const mandatoryFields = ['membership', 'name', 'mobileNumber', 'partnerClinic', 'deliveryRefill', 'orderType', 'city', 'nationality'];

        if (formData['deliveryRefill'] == 'pickup') {
            mandatoryFields.push('pharmacy');
        }

        for (let field of mandatoryFields) {
            if ((field === 'city')) {
                if (formData[field] == "") {
                    setError('Enter all mandatory fields');
                    return false;
                }
            } else if (!formData[field].trim()) {
                setError('Enter all mandatory fields');
                return false;
            }
        }

        return true;
    };

    const handleChangeCity = (selectedOption) => {
        fetchCategoryList(selectedOption.value);
        setFormData({
            ...formData,
            ['city']: selectedOption.label,
            ['cityId']: selectedOption.value,
        });
    };

    const fetchCategoryList = async (cityName) => {
        const request = axios.CancelToken.source();
        let ct = {
            cancelToken: request.token
        }
        await fetchFormDataMedication(cityName, formData['membership'])
            .then((response) => {
                if (response.data.code === 200) {
                    setPharmacyList(response.data.data.pharmacy);
                } else {
                    setError(response.data.data.message);
                }
            }).catch(function (error) {
                console.log(error);
            });
        return () => request.cancel();
    }

    const handleSubmit = async (event) => {
        setError('');
        event.preventDefault();
        if (validateForm()) {
            const request = axios.CancelToken.source();
            let ct = {
                cancelToken: request.token
            }
            setDisabledButton(true);
            await saveMedicationMetaDoc(formData)
                .then((response) => {
                    if (response.data.code === 200) {
                        getAiBupaServiceRecommendations(memberBasicInfo.membershipNumber);
                        handleFamilyMemberProfileClick(memberBasicInfo.membershipNumber)
                        setMessage(response.data.data.message);
                        //callHomeBasedServicesHistory();
                        setTimeout(() => {
                            closeModal();
                        }, 1000);
                    } else {
                        setMessage('');
                        setError(response.data.data.message);
                        setDisabledButton(false);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            return () => request.cancel();
        }
    }


    const dropdownData = async () => {
        const request = axios.CancelToken.source();
        let ct = {
            cancelToken: request.token
        }
        await fetchFormDataMedication()
            .then((response) => {
                if (response.data.code === 200) {
                    setCityList(response.data.data.city);
                    setPharmacyList(response.data.data.pharmacy);
                    setPartnerList(response.data.data.partner);
                    setFrequencyList(response.data.data.frequency);
                } else {
                    setError(response.data.data.message);
                }
            }).catch(function (error) {
                console.log(error);
            });
        return () => request.cancel();
    }


    const addComponent = () => {
        setFormData(prevState => ({
            ...prevState,
            medications: [...prevState.medications, medicationsObj],
            medicationsCount: prevState.medications.length + 1
        }));
        setAddMedicationsComponentCount(prev => prev + 1);
    };

    const addSupplierComponent = () => {
        setFormData(prev => ({
            ...prev,
            supplierMedications: [...prev.supplierMedications, supplierObj],
            suppliesCount: prev.supplierMedications.length + 1
        }));
        setAddSuppliesComponentCount(prev => prev + 1);
    };

    // const handleFieldChange = (e, index) => {
    //     const { name, value } = e.target;
    //     const list = [...formData.medications];
    //     list[index][name] = value;
    //     if (name == "productId") {
    //         list[index]["code"] = ''
    //         list[index]["productName"] = ''
    //     }

    //     setFormData({ ...formData, medications: list });
    // }

    const handleFieldChange = (e, index, listType) => {

        if (listType == 'medications') {
            const { name, value } = e.target;
            const list = [...formData.medications];
            list[index][name] = value;
            if (name == "productId") {
                list[index]["code"] = ''
                list[index]["productName"] = ''
            }

            setFormData({ ...formData, medications: list });
        } else {
            const { name, value } = e.target;
            const list = [...formData.supplierMedications];
            list[index][name] = value;

            setFormData({ ...formData, supplierMedications: list });
        }

    }

    const removeComponent = (index) => {
        setFormData((prevFormObject) => {
            const newArr = [...prevFormObject.medications];
            newArr.splice(index, 1);
            return { ...prevFormObject, medications: newArr, medicationsCount: newArr.length };
        });
        setAddMedicationsComponentCount(prevCount => prevCount - 1);
    };

    const removeSupplierComponent = (index) => {
        setFormData((prevFormData) => {
            const newArr = [...prevFormData.supplierMedications];
            newArr.splice(index, 1);
            return { ...prevFormData, supplierMedications: newArr, suppliesCount: newArr.length };
        });
    };

    // const handleSuggestionClick = (suggestion, index) => {

    //     const foundProduct = aiBupaMedicines.find(
    //         (item) => item.productId === suggestion.productId
    //     );

    //     const list = [...formData.medications];
    //     list[index]['productId'] = suggestion.productId;
    //     list[index]['productName'] = suggestion.productName;
    //     list[index]['sfdaCode'] = suggestion.sfdaCode;

    //     if (foundProduct) {
    //         list[index]['quantity'] = foundProduct.quantity;
    //         list[index]['source'] = 'aibupa';
    //         list[index]['recommendationId'] = foundProduct.recommendationId;
    //     }
    //     setFormData({ ...formData, medications: list });
    // };

    const handleSuggestionClick = (suggestion, medicationType, index) => {
        if (medicationType == 'medications') {
            const foundProduct = aiBupaMedicines.find(
                (item) => item.productId === suggestion.productId
            );

            const list = [...formData.medications];
            list[index]['productId'] = suggestion.productId;
            list[index]['productName'] = suggestion.productName;
            list[index]['sfdaCode'] = suggestion.sfdaCode;

            if (foundProduct) {
                list[index]['quantity'] = foundProduct.quantity;
                list[index]['source'] = foundProduct.source;
                list[index]['recommendationId'] = foundProduct.recommendationId;
            }
            setFormData({ ...formData, medications: list });
        } else {

            const foundProductSupplier = aiBupaMedicinesSupplies.find(
                (item) => item.productId === suggestion.productId
            );

            const listSupplier = [...formData.supplierMedications];
            listSupplier[index]['productId'] = suggestion.productId;
            listSupplier[index]['productName'] = suggestion.productName;
            listSupplier[index]['sfdaCode'] = suggestion.sfdaCode;

            if (foundProductSupplier) {
                listSupplier[index]['quantity'] = foundProductSupplier.quantity;
                listSupplier[index]['source'] = foundProductSupplier.source;
                listSupplier[index]['recommendationId'] = foundProductSupplier.recommendationId;
            }

            setFormData({ ...formData, supplierMedications: listSupplier });
        }

    };


    const handleImageClick = (url) => {
        window.open(url, '_blank');
        setIsDropdownOpen(false);
    };

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    return (
        <>

            <div className='col-md-12'>
                <div className='card card-task-appoint'>
                    <div className='card-body'>
                        <div className='card-text'></div>
                        <form id="medicationForm" onSubmit={handleSubmit}>
                            <div className="tw-flex tw-items-start tw-w-full tw-gap-4">
                                {(aiBupaServiceRecommendations[0]?.medicines?.filter(item => item.matchFound === 'N')?.length > 0 || ( formData.addressType && formData.address )) && (

                                <div className="tw-flex-grow profile-box-n1 tw-bg-[#ffedd7]/50 mb-2">
                                {aiBupaServiceRecommendations[0]?.medicines?.filter(item => item.matchFound === 'N')?.length > 0 && (
                                        <div className="tw-w-full">
                                            <div className="tw-flex tw-items-center tw-gap-2 mb-1">
                                                <span className='fw-semibold tw-text-base tw-text-gray-600'>Recommended Medications :</span>
                                                <span className=''>{getWAMessageDetails(aiBupaServiceRecommendations?.[0]?.medicines)}</span>
                                            </div>
                                            {/* <div className="col">{getWAMessageDetails(aiBupaServiceRecommendations?.[0]?.medicines)}</div> */}
                                            <div className='tw-w-full tw-flex tw-items-center tw-justify-start gap-2 tw-py-1 tw-px-2'>
                                                            {aiBupaServiceRecommendations[0]?.medicines?.filter(item => item.matchFound === 'N')?.map((refillItem, refillIndex) => (
                                                                <div key={`refill-${refillIndex}`}>
                                                                    <span className="tw-text-xs tw-font-semibold tw-text-amber-600 tw-flex tw-flex-row tw-items-center tw-w-fit tw-px-2 tw-py-1 tw-bg-white tw-rounded-xl border tw-border-amber-600/50 tw-border-2">
                                                                        <i class="bi bi-capsule-pill me-2" style={{ color: "#d97706", fontSize: "16px" }} aria-hidden="true"></i>
                                                                        {/* {refillItem.serviceDesc + " - Qty: " + refillItem.servicelineItemQuantity + " - " + moment(refillItem.serviceSupplyTo).format('D MMM, YYYY')} */}
                                                                        {refillItem.medText == ""
                                                                            ? (
                                                                                refillItem.serviceDesc + " - Qty: " + refillItem.servicelineItemQuantity + " - " + moment(refillItem.serviceSupplyTo).format('D MMM, YYYY')
                                                                            )
                                                                            : (
                                                                                refillItem.medText
                                                                            )
                                                                        }
                                                                    </span>
                                                                </div>
                                                            ))}
                                            </div>
                                        </div>
                                )}
                                {/* {formData.addressType && (formData.address || formData.latitude) &&  */}
                                {formData.addressType && formData.address && 
                                                <div className="tw-flex tw-flex-col mt-2">
                                                    <span className="mb-1 fw-semibold tw-text-base tw-text-gray-600">Delivery Information</span>
                                                    <LocationDisplay locationData={formData} />
                                                </div>
                                             } 
                                </div>
                                )}
                                {formData.mediaUrl && formData.mediaUrl?.length > 0 &&
                                    <div className="tw-flex tw-flex-col tw-items-start tw-flex-shrink-0 tw-min-w-32 tw-h-full profile-box-n1 tw-bg-[#ffedd7]/50 mb-2">
                                        <span className="tw-mb-2 -tw-mt-1 fw-semibold tw-text-base" style={{ color: '#212529' }}>
                                            View Original
                                        </span>

                                        <div className="tw-relative">
                                            <div className="tw-relative tw-inline-block">
                                                <span
                                                    // disabled={!formData.mediaUrl || formData.mediaUrl.length === 0}
                                                    onClick={toggleDropdown}
                                                    className="tw-py-1.5 tw-px-3 tw-rounded-xl hover:tw-bg-[#1279BE] hover:tw-text-white tw-transition-colors border tw-border-[#03335B] tw-text-[#03335B] tw-cursor-pointer tw-inline-block"
                                                >
                                                    <i className="bi bi-eye"></i>
                                                </span>
                                                <span className="tw-absolute tw--top-2 tw--right-2 tw-bg-blue-500 tw-text-white tw-text-xs tw-rounded-full tw-w-5 tw-h-5 tw-flex tw-items-center tw-justify-center tw-font-semibold">
                                                    {formData.mediaUrl?.length}
                                                </span>
                                            </div>

                                            {isDropdownOpen && (
                                                <div className={`tw-absolute tw-top-[calc(100%+5px)] ${aiBupaServiceRecommendations[0]?.medicines?.filter(item => item.matchFound === 'N')?.length > 0 ? 'tw-right-0' : 'tw-left-0'} tw-mt-1 tw-bg-white border tw-rounded-xl tw-overflow-hidden tw-shadow-lg tw-min-w-28 tw-z-50 tw-max-h-48 tw-overflow-y-auto`}>
                                                    {formData.mediaUrl.map((url, index) => (
                                                        <button
                                                            key={index}
                                                            onClick={() => handleImageClick(url)}
                                                            className="tw-w-full tw-px-4 tw-py-2 tw-border-none tw-text-left hover:tw-bg-[#1279BE] hover:tw-text-white tw-transition-colors tw-first:tw-rounded-t-xl tw-last:tw-rounded-b-xl tw-whitespace-nowrap"
                                                        >
                                                            Image {index + 1}
                                                        </button>
                                                    ))}
                                                </div>
                                            )}
                                        </div>

                                        {/* Click outside to close dropdown */}
                                        {isDropdownOpen && (
                                            <div
                                                className="tw-fixed tw-inset-0 tw-z-0"
                                                onClick={() => setIsDropdownOpen(false)}
                                            />
                                        )}
                                    </div>
                                }
                            </div>
                            <div className='row'>
                                <div className='col-md-6 mb-3'>
                                    <div className="row">
                                        <div className='col-md-6 mb-1'>
                                            <label className="form-label">Membership</label>
                                            <h5 className='name-label-field' name="membership">{formData['membership']}</h5>
                                        </div>
                                        <div className='col-md-6 mb-1'>
                                            <label className="form-label">Name</label>
                                            <h5 className='name-label-field' name="name">{formData['name']}</h5>
                                        </div>
                                        <div className='col-md-6 mb-3 mt-4'>
                                            <label className="form-label">Mobile Number
                                                <span className='text-danger'>*</span></label>
                                            <input type="text" name="mobileNumber" className='form-control control-input-ui' value={formData['mobileNumber']} onChange={handleChange} />
                                        </div>
                                        <div className='col-md-6 mb-3 mt-4'>
                                            <label className="form-label"> Partner Clinic
                                                <span className='text-danger'>*</span></label>
                                            <select className="form-select select-input-ui" name="partnerClinic" id="partnerClinic" value={formData['partnerClinic']} onChange={handleChange} >
                                                <option value="">-- Select Partner Clinic --</option>
                                                {partnerList.map(option => (
                                                    <option key={option.id} value={option.id}>{option.partnerName}</option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className='col-md-6 mb-3'>
                                            <label className="form-label">Nationality
                                                <span className='text-danger'>*</span>
                                            </label>
                                            <select className="form-select select-input-ui" name="nationality" id="nationality" value={formData['nationality']} onChange={handleChange} >
                                                <option value="">-- Select Nationality --</option>
                                                <option value="Indian">Indian</option>
                                                <option value="Non Indian">Non Indian</option>
                                            </select>
                                        </div>

                                        <div className='col-md-3 mb-3'>
                                            <label className="form-label">District</label>
                                            <input type="text" name="district" className='form-control control-input-ui' value={formData['district']} onChange={handleChange} />
                                        </div>

                                        <div className='col-md-3 mb-3'>
                                            <label className="form-label"> Deductible</label>
                                            <input type="text" name="deductible" className='form-control control-input-ui' value={formData['deductible']} onChange={handleChange} />
                                        </div>
                                    </div>
                                </div>

                                <div className='col-md mb-3 '>
                                    <div className="tw-grid tw-grid-cols-2 tw-gap-6">
                                        <div>
                                            <div className=' mb-3'>
                                                <label className="form-label"> Delivery Type
                                                    <span className='text-danger'>*</span>
                                                </label>
                                                <select className="form-select select-input-ui" name="deliveryRefill" id="deliveryRefill" value={formData['deliveryRefill']} onChange={handleChange} >
                                                    <option value="">-- Select Delivery Type --</option>
                                                    <option value="delivery">Delivery</option>
                                                    <option value="pickup">Pickup</option>
                                                </select>
                                            </div>

                                            <div className=' mb-3'>
                                                <label className="form-label">City
                                                    <span className='text-danger'>*</span>
                                                </label>

                                                <Select
                                                    value={cityList.find(option => option.label === formData.city) || null}
                                                    onChange={handleChangeCity}
                                                    options={cityList}
                                                    isSearchable={true}
                                                    placeholder="Select City"
                                                    className="form-control select-input-ui select-input-ui-select"
                                                />
                                            </div>

                                            <div className=' mb-3'>
                                                <label className="form-label">Remarks</label>
                                                <input type="text" name="remarks" className='form-control control-input-ui' value={formData['remarks']} onChange={handleChange} />
                                            </div>
                                        </div>

                                        <div>
                                            <div className=' mb-3'>
                                                <label className="form-label"> Order Type
                                                    <span className='text-danger'>*</span></label>
                                                <select className="form-select select-input-ui" name="orderType" id="orderType" value={formData['orderType']} onChange={handleChange} >
                                                    <option value="">-- Select Order Type --</option>
                                                    <option value="1">Refill</option>
                                                    <option value="2">New Prescription</option>
                                                </select>
                                            </div>

                                            {formData['deliveryRefill'] == 'pickup' &&
                                                <div className=' mb-3'>
                                                    <label className="form-label">Pharmacy
                                                        <span className='text-danger'>*</span>
                                                    </label>
                                                    <select className="form-select select-input-ui" name="pharmacy" id="pharmacy" value={formData['pharmacy']} onChange={handleChange} >
                                                        <option value="">-- Select Pharmacy --</option>
                                                        {pharmacyList?.map(option => (
                                                            <option key={option.id} value={option.id}>{option.pharmacyName}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            }
                                        </div>

                                    </div>
                                </div>

                                <div className='col-md-12 mb-0'>
                                    <div className='d-flex'><h5 className='name-label-field' style={{ height: 'auto', marginBottom: '0', marginRight: '5px' }}> Medications </h5> (Count:{formData['medicationsCount']})</div>
                                    {formData.medications.length > 0 && (
                                        <div className='col-12'>
                                            <div className="table-responsive">
                                                <table className="table table-borderless mb-0">
                                                    <thead>
                                                        <tr>
                                                            <td className='ps-0 pb-1'>Product <span className='text-danger'>*</span></td>
                                                            <td className='ps-0 pb-1'>Frequency <span className='text-danger'>*</span></td>
                                                            <td className='ps-0 pb-1'>Quantity <span className='text-danger'>*</span></td>
                                                            <td className='ps-0 pb-1'>Duration <span className='text-danger'>*</span></td>
                                                            <td className='ps-0 pb-1'>Supply From <span className='text-danger'>*</span></td>
                                                            <td className='ps-0 pb-1'>Supply To <span className='text-danger'>*</span></td>
                                                            <td className='ps-0 pb-1'>Comments</td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {[...Array(addMedicationsComponentCount)].map((_, index) => (
                                                            <MedicationsList c={index} key={index} showRemoveButton={showRemove} handleFieldChange={handleFieldChange} data={formData.medications[index]} frequencyData={frequencyList} removeComponent={removeComponent} listType="medications" handleSuggestionClick={handleSuggestionClick} />
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className='col-md-12 text-center mb-4'>
                                    <button type="button" className="btn btn-primary addNewRow-btn" onClick={() => addComponent()}><i className="bi bi-plus"></i> Add </button>
                                </div>

                                <div className="col-12"><hr /></div>

                                <div className='col-md-12 mb-0'>
                                    <div className='d-flex'><h5 className='name-label-field' style={{ height: 'auto', marginBottom: '0', marginRight: '5px' }}> Supplies</h5> (Count:{formData['suppliesCount']})</div>

                                    {formData.supplierMedications?.length > 0 && (
                                        <div className='col-12'>
                                            <div className="table-responsive">
                                                <table className="table table-borderless mb-0">
                                                    <thead>
                                                        <tr>
                                                            <td className='ps-0 pb-1'>Product <span className='text-danger'>*</span></td>
                                                            <td className='ps-0 pb-1'>Quantity <span className='text-danger'>*</span></td>
                                                            <td className='ps-0 pb-1'>Comments</td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {formData.supplierMedications?.map((medication, index) => (
                                                            <MedicationsSupplierList
                                                                c={index}
                                                                key={index}
                                                                showRemoveButton={true}
                                                                handleFieldChange={handleFieldChange}
                                                                data={medication}
                                                                frequencyData={frequencyList}
                                                                removeComponent={removeSupplierComponent}
                                                                listType="supplies"
                                                                handleSuggestionClick={handleSuggestionClick}
                                                            />
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                    )}
                                </div>

                                <div className='col-md-12 text-center mb-4'>
                                    <button type="button" className="btn btn-primary addNewRow-btn" onClick={() => addSupplierComponent()}>
                                        <i className="bi bi-plus"></i> Add
                                    </button>
                                </div>

                                <div className="col-12"><hr /></div>

                                <div className='col-md-12 text-center'>
                                    <div className={`${error != "" ? "errorDiv" : "hide"}`}>{error}</div>
                                    <div className={`${message != "" ? "messageDiv" : "hide"}`}>{message}</div>
                                    <Button variant="primary" type="submit" className="btn btn-primary save-btn" disabled={disabledButton}>Save Medication Request</Button>
                                </div>
                            </div>

                        </form>
                    </div >
                </div >
            </div >
        </>
    )
}
export default MedicationFormsMetaDoc;